import { useState, useEffect } from 'react'
import './DashboardMultiSelect.css'

import {
    MultiSelect,
    MultiSelectChangeEvent,
    MultiSelectFilterChangeEvent,
    // DropDownsPopupSettings,
} from '@progress/kendo-react-dropdowns'
import { Button } from '@progress/kendo-react-buttons'
import { filterBy } from '@progress/kendo-data-query'
// import {
//     fetchVendorData,
//     FetchVendorDataReturnPayload,
// } from '../../features/inventory/inventoryAPI'

interface DashboardMultiSelectProps {
    data: any[]
    selectedValues: any[]
    onSelectedValuesChanged(selectedValues: any[]): void
    noArrow?: boolean
    allowCustom?: boolean
    keyField?: string
    textField?: string
}

const DashboardMultiSelect = (props: DashboardMultiSelectProps) => {
    // const [data, setData] = useState<any>([])
    const [filteredData, setFilteredData] = useState<any[]>([])
    const [selectedValues, setSelectedValues] = useState<any[]>([])
    const [open, setOpen] = useState<boolean>(false)

    useEffect(() => {
        setFilteredData(props.data)
    }, [props.data])

    useEffect(() => {
        setSelectedValues(props.selectedValues)
    }, [props.selectedValues])

    const onChange = (event: MultiSelectChangeEvent) => {
        setSelectedValues(event.target.value)
        props.onSelectedValuesChanged(event.target.value)
    }

    const filterChange = (event: MultiSelectFilterChangeEvent) => {
        setFilteredData(filterBy(props.data.slice(), event.filter))
    }

    const onOpen = () => setOpen(true)

    const onClose = () => setOpen(false)
    const toggleDropdown = () => setOpen(!open)

    return (
        <>
            <MultiSelect
                data={filteredData}
                dataItemKey={props.keyField}
                textField={props.textField}
                filterable={true}
                value={selectedValues}
                onChange={onChange}
                onFilterChange={filterChange}
                onOpen={onOpen}
                onBlur={onClose}
                opened={open}
                allowCustom={!!props.allowCustom}
                listNoDataRender={(element: React.ReactElement<HTMLDivElement>) => {
                    if (!!props.allowCustom) return null

                    return element
                }}
            />
            {!props.allowCustom && !props.noArrow && (
                <Button
                    iconClass="k-icon k-i-arrow-60-down"
                    onClick={toggleDropdown}
                    onBlur={onClose}
                />
            )}
        </>
    )
}

export default DashboardMultiSelect
